module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres3cu"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres3cuIndex,
      "searchBoxAlias": "hres3cu",
      "detailEvent": _vm.detailEvent,
      "editEvent": _vm.editEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail-complaint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "detail": _vm.detail,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "indexSelected": _vm.indexSelected
    }
  }), _vm._v(" "), _c('detail-process', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailProcessDisp),
      expression: "detailProcessDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "detail": _vm.detail,
      "detailProcess": _vm.detailProcess,
      "detailProcessColumns": _vm.columns[_vm.dash.nowLang].detailProcess,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "searchIndex": _vm.searchIndex,
      "indexSelected": _vm.indexSelected,
      "detailPopupProcess": _vm.detailPopupProcess,
      "setDetailProcessSelected": _vm.setDetailProcessSelected,
      "receivedHres3cuDetail": _vm.receivedHres3cuDetail,
      "receivedHres3cuDetailProcessPopupCreate": _vm.receivedHres3cuDetailProcessPopupCreate,
      "receivedHres3cuDetailProcessPopup": _vm.receivedHres3cuDetailProcessPopup,
      "postHres3cuDetailprocess": _vm.postHres3cuDetailprocess,
      "postHres3cuDetailprocessPopup": _vm.postHres3cuDetailprocessPopup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bb8d518!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres3cu/component.vue
// module id = 3539
// module chunks = 1